export default "__VITE_ASSET__CRLHvLvf__"